import { Stack, Typography } from "@mui/material";
import { formatNumber } from "Utils/NumberUtils";

export type SocialStatItem = {
  id: string;
  label: string;
  count: number;
};

type Props = {
  stats: Array<SocialStatItem>;
};

/**
 * Instagram-style stat triple (count above label) shown on the public profile.
 * Type-blind — hosts map their own DTOs onto the items.
 */
export const SocialStatsRow = ({ stats }: Props) => (
  <Stack direction="row" justifyContent="center" gap={6}>
    {stats.map(({ id, label, count }) => (
      <Stack key={id} alignItems="center">
        <Typography fontWeight={600}>{formatNumber(count)}</Typography>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
